import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { CompetencyData } from "src/app/Models/competencyModel.model";
import { CompetenciesService } from "../competencies.service";
import { Router } from "@angular/router";
import { SharedcompetencyService } from "src/app/services/sharedcompetency.service";
import { AuthServiceService } from "src/app/services/auth-service.service";
import { GsdRoles } from "src/app/enums/gsdRoles.enum";
import { OthersService } from "../others/othersDataService";
import { SharedSkillService } from "../../skill-repository/shared-skill.service";
import { SkillRepositoryService } from "../../skill-repository/skill-repository.service";

@Component({
  selector: "app-competency",
  templateUrl: "./competency.component.html",
  styleUrls: ["./competency.component.css"],
})
export class CompetencyComponent implements OnInit {

  role:string;
  adminRole:number = 0;
  title: string;
  subcompetencyname: string;
  public subCompetencies: any;
  public data: any;
  public gridData: any;
  public competencyData: CompetencyData = new CompetencyData();
  public loader: boolean = false;
  public titlesubcompetency: any;
  public titlesubcompetencyId: any;
  competencyId: any;
  competencyname
  public randomText: string = `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.`;
  constructor(
    private _service: CompetenciesService,
    private _router: Router,
    private _sharedService: SharedcompetencyService,
    private auth: AuthServiceService,
    private cd: ChangeDetectorRef,
    private router: Router,
    private otherService: OthersService,
    private sharedSkillService: SharedSkillService,
    private skillRepoService: SkillRepositoryService,
  ) { }

  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 4,

    method: {},
    speed: 300,
    focusOnSelect: false,
    swipe: true,
    centerPadding: "25px",
    infinite: true,
    responsive: [
      {
        breakpoint: 1930,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          focusOnSelect: false,
          swipe: true,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          focusOnSelect: false,
          swipe: true,
        },
      },
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          focusOnSelect: false,
          swipe: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          focusOnSelect: false,
          swipe: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          swipe: true,
        },
      },

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          swipe: true,
        },
      },

      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          swipe: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
        },
      },
    ],
    nextArrow: '<button class="slick-next">Next</button> ',
    prevArrow: '<button class="slick-prev">Previous</button>',
  };


  ngOnInit() {
    this.role = this.auth.getRole();
    if (this.role.includes(GsdRoles.SuperAdmin)) {
      this.adminRole = 1;
    }
    this.fetchCompetencies();
    this.otherService.updateName('')
  }
  subTitle: Object = {
    sme: "Expert level Resources",
    certified: "Certified Resources",
    available: "Bench Pool Resources",
    pendingCertifications: "Ongoing Certifications",
    allocatedResources: "Allocated Resources",
  };


  opensubcompetencypage(comp, value){
    this.competencyId = comp.id;
    this._service.setProfileStatus(this.competencyId)
    this.competencyname = comp.title;
    this._service.setsubcompname({name:comp.titlesubcomp, id: comp.titlesubcompid})
    this.otherService.updateName(comp.titlesubcomp);
    this.titlesubcompetencyId = comp.titlesubcompid
    
    
    sessionStorage.setItem("compId", comp.id);
    sessionStorage.setItem("compTitle", comp.title);
    sessionStorage.setItem("SubcompTitle", comp.titlesubcomp);
    sessionStorage.setItem("SubcompId", comp.titlesubcompid);
    
     
    // sessionStorage.setItem("CMFSelectedSubCompId", comp.titlesubcompid);
    // sessionStorage.setItem("CMFSelectedSubCompTitle", comp.title);

    this.router.navigate([`Home/CMF Portal/${this.competencyname}`])
  }

  dataWithCount = [];
  noHeader: any;
  loading: boolean = false;
  searchText: string = "";

  getImageSrc(name) {
    switch (name) {
      case "Digital Engineering":
        return "../../../assets/images/updated-icons/Digital.png";
      case "Data Service":
        return "../../../assets/images/updated-icons/dataServices.png";
      case "Cognitive Service":
        return "../../../assets/images/updated-icons/cognative.png";
      case "Cloud Services":
        return "../../../assets/images/updated-icons/Cloud.png";
      case "Cyber Security":
        return "../../../assets/images/updated-icons/cyber_security.png";
      case "Emerging Technologies":
        return "../../../assets/images/updated-icons/emergin.png";
      case "Infrastructure & Managed Services":
        return "../../../assets/images/updated-icons/Infrastructure.png";
      case "PMO Services":
        return "../../../assets/images/updated-icons/PMO.png";
    }
  }



  fetchCompetencies() {
    this.loading = true;
    this.dataWithCount = [];
    this._service
      .GetEmployeesCountByCompetency(this.searchText)
      .subscribe(
        (response) => {
          let result = response.data;
          result.map((res) => {
            let finalObj: any = {};
            finalObj.title = res.competencyName;
            finalObj.notSubmittedCount = res.notSubmittedCount;
            finalObj.count = res.totalCount;
            finalObj.id = res.competencyId;
            this.dataWithCount.push(finalObj);
          });
          console.log("result cmf portal : ",result);
          
          this.dataWithCount.sort((a, b) => {
            let fa = a.title.toLowerCase(),
              fb = b.title.toLowerCase();

            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          });
          this.loading = false;
        },
        (error) => {
          this.dataWithCount = [];
          this.cd.detectChanges();
        }
      );
  }
}
